<template>
  <div class="payment-success">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" md="6">
          <v-card class="text-center pa-8">
            <!-- Loading state -->
            <div v-if="loading">
              <v-progress-circular
                indeterminate
                color="primary"
                size="64"
              ></v-progress-circular>
              <p class="mt-4">Verificando pago...</p>
            </div>

            <!-- Success state -->
            <div v-else-if="paymentStatus === 'complete'">
              <v-icon size="100" color="success" class="mb-4">
                mdi-check-circle
              </v-icon>
              <h1 class="text-h4 mb-4">¡Pago Exitoso!</h1>
              <p class="text-body-1 mb-4">
                Tu pago se ha procesado correctamente.
              </p>
              <v-divider class="my-4"></v-divider>
              <div v-if="sessionDetails" class="text-left">
                <p><strong>Número de sesión:</strong> {{ sessionId }}</p>
                <p v-if="sessionDetails.customer_email">
                  <strong>Email:</strong> {{ sessionDetails.customer_email }}
                </p>
              </div>
              <v-btn
                color="primary"
                class="mt-6"
                large
                @click="goToDashboard"
              >
                Ir al Dashboard
              </v-btn>
            </div>

            <!-- Pending/Processing state -->
            <div v-else-if="paymentStatus === 'open'">
              <v-icon size="100" color="warning" class="mb-4">
                mdi-clock-outline
              </v-icon>
              <h1 class="text-h4 mb-4">Pago en Proceso</h1>
              <p class="text-body-1 mb-4">
                Tu pago está siendo procesado. Recibirás una confirmación pronto.
              </p>
            </div>

            <!-- Error state -->
            <div v-else>
              <v-icon size="100" color="error" class="mb-4">
                mdi-alert-circle
              </v-icon>
              <h1 class="text-h4 mb-4">Error en el Pago</h1>
              <p class="text-body-1 mb-4">
                {{ error || 'Hubo un problema al procesar tu pago.' }}
              </p>
              <v-btn
                color="primary"
                class="mt-6"
                large
                @click="goToCheckout"
              >
                Intentar Nuevamente
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  name: 'PaymentSuccess',
  
  data() {
    return {
      loading: true,
      sessionId: null,
      paymentStatus: null,
      sessionDetails: null,
      error: null,
    };
  },

  mounted() {
    // Obtener el session_id de la URL
    this.sessionId = this.$route.query.session_id;
    
    if (this.sessionId) {
      this.checkPaymentStatus();
    } else {
      this.error = 'No se encontró información de la sesión de pago';
      this.loading = false;
    }
  },

  methods: {
    async checkPaymentStatus() {
      try {
        // Llamar a tu backend para verificar el estado del pago
        const response = await this.$http.get(
          `/api/stripe/session-status/${this.sessionId}`
        );

        this.sessionDetails = response.data;
        this.paymentStatus = response.data.payment_status;
        this.loading = false;
      } catch (err) {
        console.error('Error al verificar el estado del pago:', err);
        this.error = 'No se pudo verificar el estado del pago';
        this.loading = false;
      }
    },

    goToDashboard() {
      this.$router.push('/dashboard');
    },

    goToCheckout() {
      this.$router.push('/billing-checkout');
    },
  },
};
</script>

<style scoped>
.payment-success {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
}
</style>
